import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { forkJoin } from 'rxjs';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ReportService } from 'src/app/services/report.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-overdue-cancellation-report',
    templateUrl: './overdue-cancellation-report.component.html',
    styleUrls: ['./overdue-cancellation-report.component.scss']
})
export class OverdueCancellationReportComponent implements OnInit {


    OverdueCancellationReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    serviceProviderTypeList: any = []
    filteredList1: any = []
    LoginRoleId: any;
    sessionDataString: any;
    userListUnEncryptedCustReport: string[];
    serviceQueue: any = []
    applicationStatusTypeList: any;
    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private lookupDataService: LookupDataServiceService
    ) {
    }


    ngOnInit(): void {
        this.init()
    }
    init() {
        this.OverdueCancellationReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
        });
    }
    Reset() {
        this.OverdueCancellationReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.OverdueCancellationReportForm.controls["startDate"].value;
    }
    generateExcel() {
        debugger
         if (!this.OverdueCancellationReportForm.value.startDate && !this.OverdueCancellationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.OverdueCancellationReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.OverdueCancellationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.OverdueCancellationReportForm.value.startDate > this.OverdueCancellationReportForm.value.endDate) {
         if (this.OverdueCancellationReportForm.value.endDate) {

                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',

                })
            }
        }
        else {
            // Swal.fire({
            //     icon: 'info',
            //     title: 'Please wait while the document is being prepared for reading',
            //     showConfirmButton: true,
            //     position: 'center',
            //     timer: 6000
            // })
            this.reportService.getOverdueCancellationReport(this.OverdueCancellationReportForm.value).subscribe((data) => {
                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'Overdue Cancellation Report.xlsx';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
                else {
                    Swal.fire({
                        icon: 'warning',
                        title: 'No data Found',
                        showConfirmButton: true,
                        position: 'center',
                    })
                }
            });
        }
    }
}
